"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateInitialHighscores = void 0;
const constants_1 = __importDefault(require("./constants"));
function generateInitialHighscores() {
    let highscores = {};
    let scoreBoard = [
        {
            username: 'Heswe',
            score: '151841',
            date: '2021-02-17 08:31:42',
        },
        {
            username: 'Niserie',
            score: '123943',
            date: '2021-02-17 08:31:42',
        },
        {
            username: 'Edhellas',
            score: '117932',
            date: '2021-02-17 08:31:42',
        },
        {
            username: 'Argen',
            score: '108932',
            date: '2021-02-17 08:31:42',
        },
        {
            username: 'Sabert',
            score: '93782',
            date: '2021-02-17 08:31:42',
        },
        {
            username: 'Milindor',
            score: '85918',
            date: '2021-02-17 08:31:42',
        },
        {
            username: 'Narder',
            score: '82939',
            date: '2021-02-17 08:31:42',
        },
        {
            username: 'Cyne',
            score: '78325',
            date: '2021-02-17 08:31:42',
        },
        {
            username: 'Sige',
            score: '74929',
            date: '2021-02-17 08:31:42',
        },
        {
            username: 'Hula',
            score: '71988',
            date: '2021-02-17 08:31:42',
        }
    ];
    constants_1.default.GAME_MODE_MAP.forEach(gameMode => {
        if (gameMode.gameName !== 'mainportal') {
            highscores[gameMode.gameName] = {
                weekly: {
                    score: scoreBoard
                },
            };
        }
    });
    return highscores;
}
exports.generateInitialHighscores = generateInitialHighscores;
